import { fromSecondaryMarket } from 'state/selectors';
import type { Thunk } from 'state/state.common';
import { getWorkspaceType } from 'state/workspaces/tabs/tabs.selector';

import { getBcsProductKeyFormCpOrderTab } from '../../cpOrder.selectors';
import { isOtcBcsProductKey } from '../../cpOrder.utils';
import { getFormClientBdrId } from '../../cpOrderForm/cpOrderForm.selectors';
import { getAstroClient } from '../client/client.selector';
import { cpOrderKycActions } from './kyc.actions';

export function secondaryMarketCpOrderKycStatusRequestedThunk(tabId: string): Thunk<void> {
  return (dispatch, getState) => {
    const state = getState();
    const workspaceType = getWorkspaceType(state, tabId);
    const bcsKey = getBcsProductKeyFormCpOrderTab(state, workspaceType!, tabId);
    const isOtc = isOtcBcsProductKey(bcsKey);
    const clientBdrId = isOtc ? getAstroClient(state, tabId)?.id : getFormClientBdrId(state, tabId);
    const salesId = fromSecondaryMarket.cpOrder.form.getFormSalesId(state, tabId);
    const salesCountry = fromSecondaryMarket.cpOrder.referential.client.getSalesCountryFromId(state, tabId, salesId)!;

    if (clientBdrId !== undefined && salesCountry !== undefined) {
      dispatch(cpOrderKycActions.secondaryMarketKycStatusRequested(tabId, clientBdrId, salesCountry));
    }
  };
}
